import styled from 'styled-components';
import { Container } from 'react-bootstrap';

export const PortfolioContainer = styled(Container)`
    padding-top: 25px;
    padding-bottom: 100px;
    @media only screen and (max-width: 768px) {
        padding-top: 25px;
        padding-bottom: 25px; 
    }
`;

export const HeadTitle = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 5px;
`;

export const Title = styled.h1`
    font-family: Khula;
    font-style: normal;
    font-weight: 800;
    font-size: 50px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    border-bottom: 30px solid transparent;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 35px;
        line-height: 100%;
        display: flex;
        align-items: center;
        color: #D6E1EF;
        opacity: 0.8;
    }
`;

export const Description = styled.h3`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 100%;
        display: flex;
        align-items: center;
        color: #D6E1EF;
    }
`;

export const CallToAction = styled.button`
    width: 100%;
    margin-top: 50px;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 22px;
    text-align: center;
    color: #D6E1EF;
    outline: none;
    background: linear-gradient(90.25deg, #F06500 -21.19%, #FFA05C 126.2%);
    box-shadow: -5px -6px 16px rgba(195, 200, 205, 0.04), 6px 6px 28px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    border: none;
    height: 62px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @media only screen and (max-width: 768px) {
        margin-top: 25px;
        font-family: Khula;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.95;
    }
`;

export const ProjectCard = styled.a`
    outline: 0;
    border: none;
    font-family: 'Khula', sans-serif;
    width: 100%;
    height: 70px;
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    justify-content: flex-start;
    margin-bottom: 10px;

    background: linear-gradient(111.37deg, #32383E -60.81%, #17191C 185.78%);
    box-shadow: 6px 6px 28px rgba(0, 0, 0, 0.3), -5px -6px 16px rgba(195, 200, 205, 0.04);
    cursor: pointer;
    border-radius: 12px;
    &:active{
        box-shadow: none;
    }
    &:hover{
        box-shadow: 3px 3px 14px rgba(0, 0, 0, 0.3), -3px -3px 8px rgba(195, 200, 205, 0.04);
    }
`;

export const CardImage = styled.img`
    width: 49px;
    height: 49px;
    box-shadow: -1px 6px 11px rgba(16, 18, 20, 0.1);
`;

export const InfoContainer = styled.div`
    margin-left: 10px;
    font-family: 'Khula', sans-serif;
    max-width: 80%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
`;

export const TitleCard = styled.div`
    font-family: 'Khula', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.03em;
    color: white;
`;

export const SubtitleCard = styled.div`
    font-family: 'Khula', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
    letter-spacing: 0.03em;
    color: #9CA5AF;
    opacity: 0.7;
`;

export const ContainerListDesktop = styled.div`
    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

export const ContainerListPhone = styled.div`
    margin-top: 30px;
    @media only screen and (min-width: 768px) {
        display: none;
    }
`;
